import {
  Directive,
  HostListener,
  ElementRef,
  Renderer2,
  Optional,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCamelCase]',
})
export class AppCamelCaseDirective {
  constructor(
    private readonly el: ElementRef<HTMLInputElement>,
    private readonly renderer: Renderer2,
    @Optional() private readonly control?: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    const original = input.value.toLowerCase();
    let result = '';

    for (let i = 0; i < original.length; i++) {
      if (i === 0 || original[i - 1] === ' ') {
        // capitalize first letter or letter after space
        result += original[i].toUpperCase();
      } else {
        result += original[i];
      }
    }

    if (result !== original) {
      this.renderer.setProperty(input, 'value', result);
      if (this.control?.control) {
        this.control.control.setValue(result, { emitEvent: false });
      }
      // restore cursor position
      try {
        input.setSelectionRange(start, end);
      } catch {}
    }
  }
}
